import React from "react";
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import moment from "moment";
import { getLanguageSelected } from "beaktShared/services/session";


function MaskMoney(props) { 
    let moneyMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        thousandsSeparatorSymbol: ',',
        decimalSymbol:'.'
    })

    let language = getLanguageSelected();
    if(language === 'pt')
    {
        moneyMask = createNumberMask({
            prefix: '',
            allowDecimal: true,
            thousandsSeparatorSymbol: '.',
            decimalSymbol:','
        })
    }

    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={moneyMask}
        />
    );
}

const transformValueFormatedtoFloat = (value) =>{
    if(value === undefined)
        return 0;        
    if(value === null)
        return 0;  

    let newValue = value; 
    let language = getLanguageSelected(); 
    if(language === 'pt')
    {
        newValue = newValue.split(".").join("");
        newValue = newValue.replace(",",".");
        newValue = parseFloat(newValue);
    }
    else
    {        
        newValue = newValue.split(",").join("");
        newValue = parseFloat(newValue);
    } 
   
    return newValue;
}

const transformValueFloattoFormated = (value) =>{
    
    let valor = value;
    if(!valor)
        valor = 0;
        
    let language = getLanguageSelected();  
    if(language === 'pt')
    {
        valor = valor.toLocaleString('pt-BR');
        let index = valor.indexOf(",");      
        if(index === -1)
        {
            valor = valor + ',00';
            return valor;
        }

        let resultadoDpsDaVirgula = valor.substring(index+1,valor.length);    
        if(resultadoDpsDaVirgula.length === 1)
            valor = valor + '0';
    }
    else
    {
        valor = valor.toLocaleString('en-US');  
        let index = valor.indexOf(".");      
        if(index === -1)
        {
            valor = valor + '.00';
            return valor;
        }

        let resultadoDpsDaVirgula = valor.substring(index+1,valor.length);    
        if(resultadoDpsDaVirgula.length === 1)
            valor = valor + '0'; 
    }
    
    return valor;
}

const MaskOnlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

const MaskOnlyNumbersStart1 = (e) => { e.target.value === "0" ||  e.target.value === "" ? e.target.value = "1" : e.target.value = e.target.value.replace(/[^0-9]/g, '') };

function MaskCPF(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskRG(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\w/]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskCNPJ(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-' ,/\d/, /\d/,]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskCel(props) {
    const { inputRef, ...other } = props;
    
    return (
        <MaskedInput
        {...other}
        ref={ref => {
            inputRef(ref ? ref.inputElement : null);
        }}
        mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskCEP(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput 
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskDate(props) {
    let language = getLanguageSelected();
    const { inputRef, ...other } = props; 
    if(language === 'pt')
    {
        return (
            <MaskedInput
            {...other}
            ref={ref => { inputRef(ref ? ref.inputElement : null); }}
            mask={[ /[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            />
        );
    }
    else
    {
        return (
            <MaskedInput
            {...other}
            ref={ref => { inputRef(ref ? ref.inputElement : null); }}
            mask={[ /[0-9]/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            />
        ); 
    } 
    
}

function formateMesAno(date)
{   
    let language = getLanguageSelected();
    let dateFormated = date;
    if(language === 'pt')
        dateFormated = moment(date).format('MM/YYYY');
    else
        dateFormated = moment(date).format('MM-YYYY');
    return dateFormated;
}

function formateDate(date)
{   
    let language = getLanguageSelected();
    let dateFormated = date;
    if(language === 'pt'){
        dateFormated = moment(date).format('DD/MM/YYYY');
    }
    else{
        dateFormated = moment(date).format('MM-DD-YYYY');
    }
    return dateFormated;
}

function formateDateEN(date)
{   
    let dateFormated = date;
    dateFormated = moment(date).format('MM-DD-YYYY');
    return dateFormated;
}

function formateDateandTime(date)
{   
    let language = getLanguageSelected();
    let dateFormated = date;
    if(language === 'pt')
        dateFormated = moment(date).format('DD/MM/YYYY HH:mm');
    else
        dateFormated = moment(date).format('MM-DD-YYYY HH:mm');
    return dateFormated;
}

function validateDate(date){

    let language = getLanguageSelected();
    if(language == "pt"){
        return moment(date, 'DD/MM/YYYY',true).isValid();
    }
    else{
        return moment(date, 'MM-DD-YYYY',true).isValid();
    }
}

function validateDateMesAno(date){

    let language = getLanguageSelected();
    if(language == "pt"){
        return moment(date, 'MM/YYYY',true).isValid();
    }
    else{
        return moment(date, 'MM-DD-YYYY',true).isValid();
    }
}

function convertDate(date)
{
    let language = getLanguageSelected();
    let dateConvert = date;
    if(language === 'pt'){
        dateConvert = moment(date, 'DD/MM/YYYY').toDate();
    }
    else{
        dateConvert = moment(date, 'MM-DD-YYYY').toDate();
    }
        
    return dateConvert; 
}

function getLocale(){
  
    let language = getLanguageSelected();
    let locale = "";
    if(language === 'pt'){
        locale = "pt-br";
    }
    else{
        locale = "en-us";
    }
    return locale;   
}

function getStringFormatDate(){
  
    let language = getLanguageSelected();
    let stringformat = "";
    if(language === 'pt'){
        stringformat = "DD/MM/YYYY";
    }
    else{
        stringformat = "MM-DD-YYYY";
    }
    return stringformat;   
}

function getStringMesAno(){
  
    let language = getLanguageSelected();
    let stringformat = "";
    if(language === 'pt'){
        stringformat = "MM/YYYY";
    }
    else{
        stringformat = "MM-YYYY";
    }
    return stringformat;   
}


function MaskDecimal(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={
            createNumberMask({
                prefix: '',
                allowDecimal: true,
                thousandsSeparatorSymbol: '',
                decimalSymbol:',',
                decimalLimit: 2,
                integerLimit: 6
            })
        }
        placeholderChar={'\u2000'}
        />
    );
}

function MaskInt(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={
            createNumberMask({
                prefix: '',
                allowDecimal: false,
                thousandsSeparatorSymbol: '.',                
                integerLimit: 6
            })
        }
        placeholderChar={'\u2000'}
        />
    );
}

function MaskMonthYear(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        />
    );
}

function MaskTime(props) {
    const { inputRef, ...other } = props;    
    return (
        <MaskedInput
        {...other}
        ref={ref => { inputRef(ref ? ref.inputElement : null); }}
        mask={[ /[0-9]/, /\d/, ':', /\d/, /\d/]}
        placeholderChar={'\u2000'}
        />
    );
}

export {    
    MaskMoney,    
    MaskDecimal,
    MaskInt,
    transformValueFormatedtoFloat,
    transformValueFloattoFormated,
    MaskOnlyNumbers,
    MaskOnlyNumbersStart1,
    MaskCPF,
    MaskRG,
    MaskCNPJ,
    MaskCEP,
    MaskCel,
    MaskMonthYear, 
    MaskDate,
    formateDate,
    formateDateandTime,
    validateDate,
    validateDateMesAno,
    convertDate,
    getLocale,
    getStringFormatDate,
    getStringMesAno,
    MaskTime,
    formateMesAno,
    formateDateEN
};